
import Event = createjs.Event;

export class Poker2AntiCheatEvent extends Event {
    public params: any[];
    public static ANTI_CHEAT_REMOVE_CONNECTION: string = "antiCheatRemoveConnection";

    constructor(type: string, params: any[] = null, bubbles: boolean = false, cancelable: boolean = false) {
        super(type, bubbles, cancelable);

        this.params = params;
    }
}
